import React from "react";
import PropTypes from "prop-types";
import styles from "./SelectionSummary.module.scss";

const SelectionSummary = ({ selectedCount }) => (
  <div className={styles.selectionSummary}>
    {selectedCount > 0 ? `${selectedCount} item(s) selected` : null}
  </div>
);

SelectionSummary.propTypes = {
  selectedCount: PropTypes.number.isRequired
};

export default SelectionSummary;
